var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 547,
    viewBox: "0 0 546 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 272.862,
    cy: 273.318,
    rx: 253.228,
    ry: 253.727,
    transform: "rotate(-4.62472 272.862 273.318)",
    fill: "#92D9AA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 272.861,
    cy: 273.318,
    rx: 179.625,
    ry: 179.979,
    transform: "rotate(-4.62472 272.861 273.318)",
    fill: "#92D9AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.647 333.313C408.797 313.693 384.007 292.313 364.247 281.733C357.774 267.646 351.107 253.646 344.247 239.733C331.867 214.733 319.517 189.153 304.667 165.543C298.667 156.013 290.937 147.543 280.057 143.723C270.057 140.233 259.637 142.033 251.787 149.243C241.937 158.243 236.537 172.693 230.787 184.403C223.54 199.069 216.647 213.896 210.107 228.883C203.167 244.883 197.297 260.043 191.787 275.263C179.437 281.423 165.887 288.973 155.907 296.013C149.269 300.686 142.87 305.693 136.737 311.013C131.547 315.523 127.667 322.663 125.197 329.223C122.662 335.372 122.31 342.204 124.197 348.583C125.777 354.743 128.877 359.283 133.697 363.583C141.637 370.663 151.747 371.333 161.017 369.043C160.995 370.132 161.049 371.221 161.177 372.303C162.497 383.003 171.967 387.993 181.777 388.993C192.167 390.063 202.887 389.293 213.417 388.993C213.887 421.873 212.877 471.493 210.417 502.623C205.587 509.303 199.797 514.183 195.957 521.273C195.287 522.513 195.557 527.793 199.217 527.793H262.657C266.817 527.793 266.987 523.983 267.007 522.793C267.737 487.703 264.787 419.193 267.767 389.553C273.947 389.606 280.134 389.606 286.327 389.553C289.537 437.313 286.927 486.863 287.427 523.103C287.427 524.323 289.127 527.843 291.777 527.843H355.217C358.587 527.843 359.217 522.843 358.477 521.613C354.367 514.683 348.907 509.743 344.017 502.963C341.447 470.803 340.447 418.963 341.017 386.143H341.137C344.387 385.713 347.727 385.283 351.077 384.813C375.127 386.193 405.077 382.223 414.457 372.103C425.447 360.033 423.877 340.963 419.647 333.313Z",
    fill: "#7DB1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.127 255.273C242.427 261.566 246.183 267.177 251.887 269.853C253.299 270.457 254.753 270.958 256.237 271.353",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 239.123L258.847 246.693",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.347 239.583L287.997 246.933",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.577 318.663C333.511 321.312 340.293 326.608 344.787 333.663C345.053 334.167 345.429 334.604 345.887 334.943C346.409 335.212 346.99 335.349 347.577 335.343L376.397 337.203",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M310.257 379.603C322.762 383.617 335.814 385.664 348.947 385.673",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M371.187 330.123C369.428 331.439 368.367 333.487 368.307 335.683",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.807 333.023C205.915 329.369 209.271 323.753 210.067 317.523C209.327 319.763 208.587 322.063 208.887 324.373C209.18 326.893 210.946 328.996 213.377 329.723C216.527 330.563 219.957 328.623 221.427 326.093C222.897 323.563 222.877 320.603 222.787 317.773C222.727 315.413 222.577 312.893 220.967 310.963C218.907 308.493 215.077 307.723 211.587 307.143",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.667 299.613C226.507 300.783 229.537 302.113 231.117 304.743C232.088 306.674 232.582 308.811 232.557 310.973C232.717 313.733 232.707 316.643 231.377 319.063C230.047 321.483 226.947 323.153 224.437 322.003",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.947 328.343C145.947 328.343 185.947 302.743 209.207 289.743C212.867 287.693 216.607 285.683 220.677 284.743C228.677 282.853 237.107 284.463 245.157 286.223C248.347 286.923 251.787 289.153 251.787 293.593C251.787 298.033 248.447 298.533 245.507 299.063C239.847 300.063 231.937 300.123 226.227 300.753",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.437 317.733C237.947 318.173 239.857 322.493 239.037 325.933C238.217 329.373 235.547 332.033 232.947 334.423C231.442 335.957 229.695 337.234 227.777 338.203C225.831 339.178 223.546 339.207 221.577 338.283C219.687 337.283 217.077 331.133 217.987 329.193",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.617 333.023C202.737 345.273 176.077 364.323 162.917 369.023",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.537 338.623C306.863 346.233 303.92 354.176 301.747 362.343",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M306.377 342.323C301.537 342.443 292.197 337.993 292.197 337.993",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.808 356.943C297.458 356.153 287.728 351.623 287.728 351.623",
    stroke: "#000037",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.187 365.323C283.237 361.403 282.037 355.593 283.807 352.953C285.577 350.313 287.187 350.313 287.597 350.183C284.377 348.563 281.197 345.953 281.857 341.963C282.617 337.433 287.427 336.033 291.367 336.573C289.767 335.223 289.247 329.963 292.917 327.393C296.587 324.823 302.917 327.223 306.777 328.113C312.227 329.373 317.967 330.823 323.137 331.903L323.347 330.763C325.061 321.516 326.697 312.256 328.257 302.983C329.017 298.483 329.807 293.983 330.497 289.473C330.987 286.253 330.957 283.223 328.217 281.063C325.677 279.063 321.947 279.063 318.887 278.703L304.447 277.133L290.007 275.553C285.577 275.073 280.577 273.823 276.147 274.273C268.667 275.033 267.967 285.453 266.467 291.133C264.127 300.026 261.967 308.956 259.987 317.923C257.297 330.113 253.537 355.203 251.337 370.563C250.839 374.002 251.739 377.497 253.836 380.269C255.933 383.04 259.052 384.857 262.497 385.313C272.127 386.593 292.607 387.973 303.877 388.663C308.367 388.953 312.382 385.882 313.277 381.473C313.547 380.173 313.837 378.743 314.147 377.213C304.337 374.093 294.037 369.983 288.187 365.323Z",
    fill: "#92D9AA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/OTP.15b3b736cb6d487c455b75538d273e81.svg";
export { ForwardRef as ReactComponent };